import {
  Row,
  Divider,
} from "antd";
import get from "lodash/get";
import round from "lodash/round"
import GraphGrid from "../graphGrid";
import { getTransformedMinutes } from "../../../utilities/helpers";

const CncContent = ({selectedTemplate, filter,data}) => {
  return (
       <Row id="content-container ">
        <GraphGrid
          graphId={1}
          type="day"
          stats={get(data, "on_off_graph", [])}
          label={"On / Off / Idle"}
          statistics={[
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_off_hours", 0)?round(get(selectedTemplate, "meta.total_off_hours", 0)):0
              ),
              // value:get(selectedTemplate, "meta.total_off_hours"),
              label: "Off Hours",
            },
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_idle_hours", 0)?round(get(selectedTemplate, "meta.total_idle_hours", 0)):0
              ),
              label: "Idle  Hours",
            },
            {
              value: getTransformedMinutes(
                get(selectedTemplate, "meta.total_working_hours", 0)?round(get(selectedTemplate, "meta.total_working_hours", 0)):0
              ),
              label: "Working Hours",
            },
          ]}
               selectedTemplate={selectedTemplate}
           filter={filter}
        />
        <Divider />
        <GraphGrid
          graphId={2}
          type="day"
          label={"Count"}
          stats={get(data, "count_graph", [])}
          statistics={[
            {
              value: get(selectedTemplate, "meta.total_count", 0)?round(get(selectedTemplate, "meta.total_count", 0)):0,
              label: "Counts",
            },
          ]}
               selectedTemplate={selectedTemplate}
           filter={filter}
        />
        <Divider />
        <GraphGrid
          type="day"
          graphId={3}
          label={"Machining Time"}
          stats={get(data, "machining_time_graph", [])}
          statistics={[
            {
              value: `${get(selectedTemplate, "meta.avg_machining_time", 0)?round(get(selectedTemplate, "meta.avg_machining_time", 0)):0} Sec`,
              label: "Machining time",
            },
          ]}
               selectedTemplate={selectedTemplate}
           filter={filter}
        />
        <Divider />
        <GraphGrid
          graphId={4}
          type="day"
          label={"Non-Machining Time"}
          stats={get(data, "non_machining_time_graph", [])}
          statistics={[
            {
              value: `${get(selectedTemplate, "meta.avg_non_machining_time", 0)?round(get(selectedTemplate, "meta.avg_non_machining_time", 0)):0} Sec`,
              label: "Non-Machining time",
            },
          ]}
               selectedTemplate={selectedTemplate}
           filter={filter}
        />
        <Divider />
        {get(data, "power_consumption_graph") && (
          <GraphGrid
            type="day"
            graphId={5}
            label={"Power Consumption"}
            stats={get(data, "power_consumption_graph", [])}
            statistics={[
              {
                value: `${get(
                  selectedTemplate,
                  "meta.total_power_consumption",
                  0
                )?round(get(
                  selectedTemplate,
                  "meta.total_power_consumption",
                  0
                )):0} Kwh`,
                label: "Power Consumption",
              },
            ]}
                 selectedTemplate={selectedTemplate}
           filter={filter}
          />
        )}
      </Row>
  )
}

export default CncContent